import { TMoneyGuaranteeProps } from '@/components/moneyGuarantee/types'

import { TextHTML } from '../typography'

export const MoneyGuarantee = ({
  guarantee,
  secondPart,
  firstPart,
  image,
}: TMoneyGuaranteeProps) => {
  return (
    <div className="money-guarantee">
      <div className="inner">
        <div className="title">{guarantee}</div>
        <div className="text-block">{firstPart}</div>
        <TextHTML className="text-block" title={secondPart} />
        {image && <div className="image">{image}</div>}
      </div>
    </div>
  )
}
